// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"4b308d4a","574":"cdf25fa3","809":"d2c40891"}[chunkId] + ".chunk.js";
};